import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function BankingLicense (){

    return (
        <main className='main'>

            <SEO
                title="Banking Licenses | Offshore Bank Setup Services"
                description="Get banking licenses for commercial, private, or digital banks. Offshore Advisory provides full support from application to compliance setup."
                keywords="banking license services, offshore bank license, commercial bank license, private bank license, digital bank license, financial institution license, bank setup offshore, banking compliance services"
                url="/banking-license"
            />

            <IntroSection
                title="Banking Licenses"
                subtitle="Establish Your Own Bank with Offshore Advisory"
                description={`
                    <b>Offshore Advisory</b> assists <b>investors, financial groups, and fintech entrepreneurs</b> in obtaining <b>Banking Licenses</b> across <b>strategic offshore and mid-tier jurisdictions</b>. Whether you need a <b>Commercial Bank License, Private Bank, Digital Bank, or Specialized Niche Bank</b>, we provide <b>end-to-end support — from application preparation to compliance setup</b>.
                `}
                badges={
                    [
                        "Offshore Banking Licenses",
                        "Private & Digital Banking",
                        "Regulatory Compliance"
                    ]
                }
                buttonText="Request a Banking License Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/banking-license-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Obtain a Banking License?'
                        subtitle='A banking license allows you to:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Offer Banking Services",
                                            text: "Deposits, loans, custody, and payments."
                                        },
                                        {
                                            title: "Access Global Banking Networks",
                                            text: "SWIFT, IBAN, SEPA integration."
                                        },
                                        {
                                            title: "Build Client Trust",
                                            text: "Licensed banks enjoy credibility worldwide."
                                        },
                                        {
                                            title: "Provide Financial Privacy",
                                            text: "Through recognized legal frameworks."
                                        },
                                        {
                                            title: "Expand Fintech & Digital Banking",
                                            text: "Combine with EMI/PSP licenses."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Types of Banking Licenses We Offer"
                        item={
                            [
                                {
                                    title: "Commercial Banking License",
                                    text: "Retail deposits, loans, card issuance."
                                },
                                {
                                    title: "Private Banking License",
                                    text: "Wealth management, HNW client services."
                                },
                                {
                                    title: "Digital / Neo Banking License",
                                    text: "Online-only banks with fintech focus."
                                },
                                {
                                    title: "Investment Banking License",
                                    text: "Securities, M&A, corporate advisory."
                                },
                                {
                                    title: "Niche Banking Licenses",
                                    text: "Crypto banks, trade finance, offshore merchant banks."
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Jurisdictions for Banking Licenses"
                        blocks={[
                            {
                                title: "Offshore / Emerging Jurisdictions",
                                items:
                                    [
                                        {
                                            title: "Western Sahara (CRA)",
                                            text: "Banking License Type A (Commercial/Private) & Type B (Digital/Investment)."
                                        },
                                        {
                                            title: "Mwali (Comoros)",
                                            text: "Internationally recognized banking framework."
                                        },
                                        {
                                            title: "Anjouan (Comoros)",
                                            text: "Fast setup for boutique/private banks."
                                        },
                                        {
                                            title: "Dominica / St. Lucia",
                                            text: "Flexible Caribbean options."
                                        }
                                    ]
                            },
                            {
                                title: "Mid-Tier & Recognized Hubs",
                                items:
                                    [
                                        {
                                            title: "Mauritius",
                                            text: "Global Business Bank License, Africa–Asia hub."
                                        },
                                        {
                                            title: "Vanuatu",
                                            text: "Cost-efficient, widely accepted for offshore banking."
                                        },
                                        {
                                            title: "Belize",
                                            text: "Established offshore banking framework."
                                        }
                                    ]
                            },
                            {
                                title: "High-Tier / EU & Advanced",
                                items:
                                    [
                                        {
                                            title: "Cyprus",
                                            text: "EU-licensed banking institutions."
                                        },
                                        {
                                            title: "Malta",
                                            text: "Recognized for fintech & digital banking."
                                        },
                                        {
                                            title: "Switzerland & Luxembourg",
                                            text: "Premium private banking jurisdictions (high cost, high regulation)."
                                        }
                                    ]
                            },
                        ]}
                    />


                    <ServiceCards
                        title='Our Banking License Services Include'
                        services={
                            [
                                {
                                    title: "company-formation & Legal Setup",
                                },
                                {
                                    title: "Banking License Application Drafting & Submission",
                                },
                                {
                                    title: "Compliance Support",
                                    text: "AML/KYC, FATF standards"
                                },
                                {
                                    title: "SWIFT/IBAN/SEPA Integration",
                                },
                                {
                                    title: "Core Banking Software",
                                    text: "White-label solutions"
                                },
                                {
                                    title: "Business Plans, Risk Frameworks, and Manuals",
                                },
                                {
                                    title: "Nominee Directors & Compliance Officers",
                                    text: "Where required"
                                }
                            ]
                        }
                        />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                description: "Offshore licenses (Western Sahara, Mwali, Anjouan)",
                                duration: "2-8 weeks",
                            },
                            {
                                description: "Mid-tier (Mauritius, Vanuatu, Belize)",
                                duration: "6–12 months",
                            },
                            {
                                description: "EU & top-tier",
                                duration: "12–18 months+",
                            },

                            {
                                description: "Offshore Banking Licenses",
                                price: "USD 18,000 – 30,000+",
                            },
                            {
                                description: "Mid-Tier Banking Licenses",
                                price: "USD 150,000 – 300,000",
                            },
                            {
                                description: "EU / Premium",
                                price: "USD 1M+ regulatory capital required",
                            },

                        ]}
                        end='Exact fees depend on jurisdiction, license type, and services bundled.'
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "Ready to start your own bank?"
                         description=
                             "From <b>offshore boutique banks</b> to <b>EU-recognized institutions</b>, <b>Offshore Advisory</b> provides <b>complete banking license solutions</b>."
                         buttonText='Book a Banking License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the difference between Type A and Type B Banking Licenses in Western Sahara?",
        content: [
            { type: "list",
                items: [
                    "<strong>Type A: </strong> Full-service banks (retail/commercial/private).",
                    "<strong>Type B: </strong> Digital, niche, or investment-focused banks.",

                ] },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "Offshore licenses typically require lower capital (USD 250k–2M), while EU licenses can require €5M–€10M+." },
        ],
    },
    {
        question: "Can I issue debit/credit cards under a banking license?",
        content: [
            { type: "answer", text: "Yes — most jurisdictions allow card issuing through Visa/Mastercard partnerships." },
        ],
    },
    {
        question: "Can I combine a banking license with fintech services?",
        content: [
            { type: "answer", text: "Yes — many clients combine Banking + EMI + Crypto Licenses for maximum flexibility." },
        ],
    },
    {
        question: "How do you assist with compliance?",
        content: [
            { type: "answer", text: "We prepare AML/KYC manuals, appoint compliance officers, and maintain reporting to regulators." },
        ],
    },

];

const testimonialsData = [
    {
        quote:
            "We obtained a Type A Banking License in Western Sahara with Offshore Advisory’s help. The process was clear and efficient.",
        author: "Mark L.",
        role: "Banking Investor",
    },
    {
        quote:
            "Thanks to their guidance, we launched a digital bank in Mauritius, fully integrated with SEPA and SWIFT.",
        author: "Sofia D.",
        role: "FinTech Entrepreneur",
    },
];